export default [
  'Arial Black',
  'Arial',
  'Brightly Crush Shine', 
  'Gothic',
  'Tusker',
  'Dearest',
  'Chasy', 
  'Sketch Gothic School',
  'Chicken Pie',
  'Down Hill',
  'Hanged Letters',
  'Trucking',
  'Ling',
  'Loving You',
  'Margetha',
  'Mathline',
  'Muthiara',
  'Retrow Mentho',
  'Samble Tracie',
  'Summer Vibes',
  'Vogue'
];
